import React from "react";
import { Drawer, Box } from "@mui/material";

const DrawerContentSx = { width: 450, height: "100%" };

const CustomDrawer = ({ children, open = false, onClose = () => {} }) => {
  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box sx={DrawerContentSx} role="presentation">
        {children}
      </Box>
    </Drawer>
  );
};

export default CustomDrawer;
